export function isAuthenticated(session) {
    return session.user && session.token && session.key
}

export function canRecover(session) {
    return !!session.token
}

// Only for cache usage !
let cachedToken = null;
let cachedLanguage = null;
let cachedKey = null;

function saveToken(token) {
    cachedToken = token
    localStorage.setItem('token', token)
}

function saveLanguage(language) {
    cachedLanguage = language
    localStorage.setItem('language', language)
}

function saveKey(key) {
    cachedKey = key
    localStorage.setItem('key', key)
}

export function loadToken() {
    cachedToken = localStorage.getItem('token')
    return cachedToken
}

export function loadLanguage() {
    cachedLanguage = localStorage.getItem('language')
    return cachedLanguage
}

export function loadKey() {
    cachedKey = localStorage.getItem('key')
    return cachedKey
}

function clearToken() {
    cachedToken = null
    localStorage.removeItem('token')
}

function clearLanguage() {
    cachedLanguage = null
    localStorage.removeItem('language')
}

function clearKey() {
    cachedKey = null
    localStorage.removeItem('key')
}

export function tokenListener(store) {
    const token = store.getState().session.token
    if (token !== cachedToken) {
        if (token) {
            saveToken(token);
        } else {
            clearToken();
        }
    }
}

export function languageListener(store) {
    const language = store.getState().session.language
    if (language !== cachedLanguage) {
        if (language) {
            saveLanguage(language);
        } else {
            clearLanguage();
        }
    }
}

export function keyListener(store) {
    const key = store.getState().session.key
    if (key !== cachedKey) {
        if (key) {
            saveKey(key);
        } else {
            clearKey();
        }
    }
}


// WEBPACK FOOTER //
// ./src/services/sessionService.js